export default __webpack_public_path__ + "static/media/template12.3009c24d.svg";